import {TimeValue} from "../../../fields3/generic/datetime/time/types"

const debug = false
// const debug = "stringToTimeOfDay"

export function stringToTimeOfDay(userInput: string): TimeValue | null {

    if (!userInput) return null

    const timeRegex = /(\d{1,2})(:(\d{1,2}))?(\s*([APMapm]{2}))?/ // Updated regular expression

    const match = userInput.match(timeRegex)

    if (!match) {
        return null // Invalid input. Return null.
    }

    debug && console.log(debug, 'process', match)

    const [, hourStr, , minuteStr, , ampm] = match
    let hours = parseInt(hourStr, 10)
    let minutes = !minuteStr ? 0 : parseInt(minuteStr, 10)

    if (
        hours >= 0 &&
        hours < 24 &&
        minutes >= 0 &&
        minutes < 60 &&
        ((ampm && /^(AM|PM|am|pm)$/.test(ampm)) || !ampm)
    ) {
        if (ampm) {
            const isPM = /^(PM|pm)$/.test(ampm)
            if (hours !== 12) {
                hours += isPM ? 12 : 0
            } else {
                hours = isPM ? 12 : 0
            }
        }

        return { hours, minutes }
    } else {
        return null // Invalid time. Return null.
    }
}

// // Example usage:
// const userInput = '14:30';
// const timeOfDay = convertToTimeOfDay(userInput);
// console.log(timeOfDay); // Output: Good afternoon!
